
import React from "react";
import './../styles/index.css';

import { useTimer } from 'react-timer-hook';

export default function CountDownTimer(props) {
  const { selectTimerStop } = props; //to pass combi back to the parent playsound.js
  
  const MyTimer = ({ expiryTimestamp }) => {


    const {
      seconds,
      minutes,
    } = useTimer({
      expiryTimestamp, onExpire: () => { updateValues(); }
    });



    return (
      <div>
            <span>{minutes < 10 && <>0</>}{minutes}</span>:<span>{seconds < 10 && <>0</>}{seconds}</span>
      </div>
    );

  }

  const updateValues = () => {
    selectTimerStop(true);
  }

  let duration = props.duration; //format minute:seconds
  let durationArray = duration.split(":");
  let mySeconds = (parseInt(durationArray[0]) * 60) + parseInt(durationArray[1]);


  const time = new Date();
  time.setSeconds(time.getSeconds() + mySeconds); // add seconds to current timer

  return (
    <div>
       <MyTimer expiryTimestamp={time} />
    </div>
  );




}